export default {"src":"/_next/static/media/Arrow-down-white.43b55df0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};